import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { Code, CodeDTO } from "./code";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";

export interface OptionV1DTO {
  code: CodeDTO;
  option: SurveyLocalizedTextDTO;
}

export class OptionV1 {
  readonly isOptionV1OptionV1: boolean = true;

  readonly code: Code;
  readonly option: SurveyLocalizedText;


  constructor(
  code: Code, 
  option: SurveyLocalizedText
  ) {
    this.code = code;
    this.option = option;
  }

  static fromDTO(dto: OptionV1DTO): OptionV1 {
    const code = Code.fromDTO(getObject(dto, "code", InvalidOptionV1CodeError));
    const option = SurveyLocalizedText.fromDTO(getObject(dto, "option", InvalidOptionV1OptionError));
    return new OptionV1(
      code,
      option
    );
  }

  toDTO(): OptionV1DTO {
    const dto: OptionV1DTO = {
        code: this.code.toDTO(),
        option: this.option.toDTO()
    };
    return dto;
  }
  }

OptionV1.prototype.toString = function toString(): string {
  return `OptionV1(code='${this.code}',option='${this.option}')`;
};

export class InvalidOptionV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOptionV1Error";
  }
}
export class InvalidOptionV1CodeError extends InvalidOptionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOptionV1CodeError";
  }
}

export class InvalidOptionV1OptionError extends InvalidOptionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOptionV1OptionError";
  }
}
